import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/profile/personal_icon_vip.png'
import _imports_1 from '@/assets/profile/arrow_right_white45.png'


const _hoisted_1 = { class: "card_content" }
const _hoisted_2 = { class: "vip_num" }
const _hoisted_3 = { class: "bar" }

import { useUserStore } from '@/stores/user'
import { clickOnCard } from '@/view/profile/supportScript'
import { computed, ref } from 'vue'
import { useRouter } from 'vue-router'

export default /*@__PURE__*/_defineComponent({
  __name: 'vipCard',
  setup(__props) {

const router = useRouter()
const userStore = useUserStore()
const isPopping = ref(false)
const currentLevel = computed(() => userStore.VIPData.currentLevel)
const betTotal = computed(() => userStore.VIPData.cumulativeBetTotal)
const betMin = computed(() => userStore.VIPData.bet_min)
const nextLevel = computed(() => userStore.VIPData.nextLevel)
const isVIPLevelEnd =  computed(() => userStore.isHighestVIPlevel)

const onClickCard = () => clickOnCard(router, isPopping, '/sd-vip')

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_unref(userStore).vipAvailable)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["container", { 'pop-animate': isPopping.value }]),
        onClick: onClickCard
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_van_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_van_col, {
                span: "5",
                class: "crown"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_2, "V" + _toDisplayString(currentLevel.value), 1),
                  _cache[0] || (_cache[0] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t('profile.apostate')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_van_col, {
                span: "18",
                offset: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_row, { class: "right_content" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "23",
                        class: "text_icon"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(isVIPLevelEnd.value ? _ctx.$t('vip.highestLevelAchived') : _ctx.$t('profile.followVIP1', { level: nextLevel.value }) + betMin.value) + " ", 1),
                          _cache[1] || (_cache[1] = _createElementVNode("img", {
                            src: _imports_1,
                            alt: ""
                          }, null, -1))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, { span: "24" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", {
                              class: "progress",
                              style: _normalizeStyle({ width: betTotal.value / betMin.value < 1 ? betTotal.value * 100 / betMin.value + '%' : '100%' })
                            }, null, 4),
                            _createElementVNode("div", {
                              class: "progress-end-dot",
                              style: _normalizeStyle({ left: `calc(${betTotal.value * 100 / betMin.value}% - 6px)` })
                            }, null, 4)
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "24",
                        class: "progress_bar"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(betTotal.value) + " / " + _toDisplayString(betMin.value), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ], 2))
    : _createCommentVNode("", true)
}
}

})